module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-en3.b83adc2.png";